<template>
    <div class="mt-0">
        <div class="row p-2 mt-3" id="lower-div">
            <div class="card mb-4">
                <div v-loading="loading">
                    <Table @get-data="GetExceptionTypes" :data="data"></Table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Table from "./Components/Table.vue";

export default {
    components: {
        Table
    },
    data() {
        return {
            firstVis: true,
            loading: null,
            data: [
                {
                    id: 1,
                    value: "Tərəflərin qarşılıqlı razılığı ilə Sığortalı I-in hüquq və vəzifələri Sığortalı II-yə keçə bilər.",
                    created: "2025-08-01 14:32",
                    updated: "2025-08-05 10:12"
                },
                {
                    id: 2,
                    value: "Sığorta olunan öz iş yerini dəyişdirdiyi təqdirdə, Sığortalı, işçinin xeyrinə bağlanmış həyatın yığım sığortası şəhadətnaməsi üzrə öz hüquq və vəzifələrini Sığortaçının və yeni işəgötürənin razılığı ilə sonuncuya ötürür. Bu halda sığorta olunanın yeni işəgötürəni bu şəhadətnamə üzrə Sığortalı qismində çıxış edir.",
                    created: "2025-08-02 09:15",
                    updated: "2025-08-10 16:45"
                },
                {
                    id: 3,
                    value: "Şəhadətnamə bağlanarkən və sığorta məbləği artırılarkən Sığortaçı Sığorta olunanın müvafiq ərizə formasını doldurmasını və şəhadətinin tibbi müayinədən keçməsini tələb etmək hüququna malikdir. Bu zaman müayinənin aparılacağı tibb müəssisəsi Sığortaçı ilə razılaşdırılmaqla Sığortaçı tərəfindən müəyyən edilir. Sığorta olunanın səhhəti ilə bağlı onun tərəfindən təqdim edilən məlumat əsasında və tibbi müayinənin nəticəsindən asılı olaraq Sığortaçı sığorta şərtlərinin dəyişiklikləri etməklə hüququna malikdir. Sığorta olunan tibbi müayinədən keçməkdən imtina edəcəyi halda Sığortaçı həmin şəxslə Sığorta şəhadətnaməsinin bağlanmasından və ya artıq bağlanmış şəhadətnaməyə əlavı yazmaqdan imtina edə bilər.",
                    created: "2025-08-03 11:22",
                    updated: "2025-08-11 13:05"
                },
                {
                    id: 4,
                    value: "Sığorta ödənişi faydalanan şəxs tərəfindən gələcəkdə təqdim olunacaq bank rekvizitləri üzrə bank köçürməsi ilə həyata keçiriləcək.",
                    created: "2025-08-04 17:05",
                    updated: "2025-08-12 08:50"
                },
                {
                    id: 5,
                    value: "Sığorta olunan bu şəhadətnamənin qüvvədə olduğu müddət ərzində Bankdan kredit götürərsə, və həmin kreditin qaytarılmasının təminatı üsulu kimi Sığortaçıya ödənilmiş sığorta haqları çıxış edərsə (girov, zəmanət və s.), Sığorta şəhadətnaməsinə vaxtından əvvəl xitam verildikdə, kredit müddəti bitən tarixə qədər ödənilməməsi halında Bank öz tələblərini Sığortaçı tərəfindən kreditin ödənilməsinin təminatı üsulu kimi çıxış edən pul məbləğinə (sığorta haqlarına) yönəltdikdə (sildikdə), Sığortaçı hüququsunun sığorta məbləğini və ya qaytarılan məbləğini Faydalanan şəxsə (Sığortalıya) ödəmək vəzifəsindən azad olur (Sığortalı həmin məbləği qaldır öz öhdəliyini icra etmiş sayılır).",
                    created: "2025-08-04 17:05",
                    updated: "2025-08-12 08:50"
                },
                {
                    id: 6,
                    value: "Nəzərə alınır ki, Sığortalının seçiminə və istəyinə əsasən onun ödədiyi sığorta haqları (Deposit bank adı) ASC-də olan {Deposit account number} saylı cari hesaba investisiya edilmişdir, Bank müflis olduqda və ya istənilən başqa səbəbdən {Policy issue date}-ci il tarixli {Policy number} nömrəli annuitet müqaviləsi üzrə Sığortaçı qarşısında öhdəliklərini yerinə yetirə bilmədikdə Sığortaçı, həmin annuitet müqaviləsi üzrə öhdəliklərin icra edilmədiyi müddətdə bu şəhadətnamənin və ya şəhadətnamə üzrə faydalanan şəxslər qarşısında öhdəliklərin icrasından azaddır.",
                    created: "2025-08-04 17:05",
                    updated: "2025-08-12 08:50"
                },
                {
                    id: 7,
                    value: "Əmanət Müqaviləsi üzrə əmanət məbləğin hesablanan faiz dərəcəsi və ya şərtlər dəyişdikdə Sığortaçı sığorta məbləğini və qaytarılan məbləği Əmanət müqaviləsindəki dəyişdirilmiş faiz dərəcəsi və şərtlər əsasında yenidən hesablayıb dəyişdirmək hüququna malikdir. Bu halda Sığorta şəhadətnaməsinə müvafiq dəyişikliklər edilir.",
                    created: "2025-08-04 17:05",
                    updated: "2025-08-12 08:50"
                },
                {
                    id: 8,
                    value: "Bütün ödənişlər və təzminatlar Azərbaycan Respublikasl Mərkəzi Bankının ödəniləcəyi günə olan məzənnəsi əsasında milli valyuta olan Azərbaycan manatı ilə həyata keçirilir.",
                    created: "2025-08-04 17:05",
                    updated: "2025-08-12 08:50"
                },
                {
                    id: 9,
                    value: "Azərbaycan Respublikasının Mülki Məcəlləsinin 422-ci maddəsində nəzərdə tutulmuş hallı baş verdiyi təqdirdə Sığortaçı şəhadətnaməni birtərəfli qaydada dəyişdirmək hüququna malikdir.",
                    created: "2025-08-04 17:05",
                    updated: "2025-08-12 08:50"
                }
            ],
            navNumber: 1
        }
    },
}
</script>